module.exports = __webpack_public_path__ + "static/media/paris.f580587b.png";